import { TASK_STATUSES } from "shared/types/enums";

import { ConfigurationTypeData } from "../types";
import SingleStatus from "./SingleStatus";
import { SYNC_STATUSES } from "./types";

const SyncStatus = ({ data }: ConfigurationTypeData) => {
    const { configurationChange, hasFeatureFlag } = data;

    const renderData = () => {
        // Device is not connected (null), feature is not supported (false), or task doesn't exist
        if (!hasFeatureFlag || !configurationChange?.task) {
            return "-";
        }

        const { status_id } = configurationChange.task;

        // SYNCING
        if (
            status_id === TASK_STATUSES.Pending ||
            status_id === TASK_STATUSES.Running ||
            status_id === TASK_STATUSES.Verifying
        ) {
            return <SingleStatus status={SYNC_STATUSES.Syncing} />;
        }

        // FAILED
        if (
            status_id === TASK_STATUSES.Failed ||
            status_id === TASK_STATUSES.Expired
        ) {
            return <SingleStatus status={SYNC_STATUSES.Failed} />;
        }

        // CANCELLED
        if (status_id === TASK_STATUSES.Cancelled) {
            return <SingleStatus status={SYNC_STATUSES.Cancelled} />;
        }

        // COMPLETED
        if (
            status_id === TASK_STATUSES.Completed ||
            status_id === TASK_STATUSES.CompletedWithErrors
        ) {
            return <SingleStatus status={SYNC_STATUSES.Completed} />;
        }

        return "-";
    };

    return <div>{renderData()}</div>;
};

export default SyncStatus;
